import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=4528e511&scoped=true&"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528e511",
  null
  
)

export default component.exports